module.exports = __webpack_public_path__ + "static/media/29df5bb8d97307eae7f595d7636e9845.29df5bb8.ttf";